<template>
  <div>
    <li class="menu-item" v-if="!hasSubLinks">
      <a
        class="menu-item__link"
        v-if="isExternal"
        :href="path"
        target="_blank"
        ref="externalLink"
      >
        <span class="menu-item__link-content">
          <slot></slot>
          <span>{{ title }}</span>
        </span>
      </a>
      <router-link class="menu-item__link" v-else :to="path">
        <span class="menu-item__link-content">
          <slot></slot>
          <span>{{ title }}</span>
        </span>
      </router-link>
    </li>

    <li class="menu-item" v-if="hasSubLinks">
      <div class="menu-item__accordion">
        <div class="menu-item__accordion--parent" @click="toggleSubLinks">
          <span> {{ title }} </span>
          <chevron-Down class="menu-item__accordion-chevron"></chevron-Down>
        </div>

        <div v-show="showSubLinks">
          <li
            v-for="(link, index) in subLinks"
            :key="index"
            class="menu-item accordion__sub"
          >
            <router-link
              class="menu-item__link"
              :to="link.path"
              v-if="!link.hidden"
            >
              <span class="menu-item__link-content">
                <slot></slot>
                <span>{{ link.meta.title }}</span>
              </span>
            </router-link>
          </li>
        </div>
      </div>
    </li>
  </div>
</template>

<script>
import Chevron from "@/assets/svg/Chevron.svg"
export default {
  props: {
    path: String,
    title: String,
    isExternal: Boolean,
    hasSubLinks: {
      type: Boolean,
      default: false
    },
    route: Object
  },
  data() {
    return {
      showSubLinks: false,
      subLinks: []
    }
  },
  components: {
    chevronDown: Chevron
  },
  methods: {
    toggleSubLinks() {
      let chevron = document.getElementsByClassName(
        "menu-item__accordion-chevron"
      )
      chevron[0].style.transition = "all 0.3s"
      chevron[0].style.transform = !this.showSubLinks
        ? "rotate(180deg)"
        : "rotate(0deg)"
      this.showSubLinks = !this.showSubLinks
    }
  },
  mounted() {
    if (this.route.meta.hasSubLinks == true) {
      this.subLinks = this.route.children[0].children
    }
  }
}
</script>

<style scoped rel="stylesheet/scss" lang="scss">
@import "@/styles/variables.scss";
.menu-item {
  $self: &;
  display: flex;
  list-style: none;
  margin-bottom: 14px;
  a {
    color: #fff;
    padding: 12px 6px;
    width: 100%;
    text-align: left;
    position: relative;
    font-family: Muli;
    font-size: 13px;
    font-weight: 800;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.23;
    letter-spacing: normal;
    text-align: left;
    color: #ffffff;
    &:before {
      content: "";
      height: 82%;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      transition: all 0.3s ease;
    }

    &:hover::before,
    &:focus::before,
    &.router-link-exact-active::before,
    &.router-link-active::before {
      background-color: $color-accent;
      background-color: var(--color-accent, $color-accent);
      transform: scale(1.25, 1.125) translateX(-12px);
      box-shadow: 0px 10px 24px -10px rgba(0, 0, 0, 0.75);
      margin-top: 2px;
      z-index: 2;
    }
    #{$self}__link-content {
      margin-left: 16px;
      z-index: 3;
      position: relative;
      span {
        font-size: 0.866em;
        margin-left: 28px;
        position: relative;
        top: -2px;
      }
    }
  }
  &__accordion {
    width: 100%;
    &--parent {
      padding: 0 20px;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-family: Muli;
      font-size: 13px;
      font-weight: 800;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.23;
      letter-spacing: normal;
      text-align: left;
      color: #ffffff;
      cursor: pointer;
    }
    .accordion__sub {
      margin-bottom: 0px;
      text-transform: none;
    }
  }
}
</style>
